import { api } from 'app/config/apiConfig';
import { USERS_PATH } from '../utils/constants';
import { Pagination } from 'app/types/common';
import { UserBalanceAction } from '../model/types';

interface Params {
  userId: string;
  page?: number;
  limit?: number;
  orderBy?: string;
}

export const getUserBalanceActionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserBalanceActions: builder.query<Pagination<UserBalanceAction>, Params>({
      query: (params) => ({
        url: `${USERS_PATH}/${params.userId}/balance/actions`,
        params,
      }),
      providesTags: ['User balance actions'],
    }),
  }),
});

export const { useGetUserBalanceActionsQuery } = getUserBalanceActionsApi;
